/*
 * @Descripttion:中奖者
 * @Author: lc
 * @Date: 2021-10-25 08:33:06
 * @LastEditors: lc
 * @LastEditTime: 2021-10-27 17:14:25
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const winner = {
    // 列表
    list(params) {
        return axios.get(api + 'winner/list', { params: params })
    },
    //商品列表
    productgoodlist(params) {
        return axios.get(api + 'winner/productgoodlist', { params: params })
    },
    //添加
    create(params) {
        return axios.post(api + 'winner/create', qs.stringify(params))
    },
    //更改状态
    status(params) {
        return axios.post(api + 'winner/status', qs.stringify(params))
    },
}


// 导出接口
export default winner

